import { PayloadAction } from '@reduxjs/toolkit'
import { affiliate, affiliatesState } from 'src/core/models/affiliate-center.interface'

const reducers = {
  setAffiliate: (state: affiliatesState, action: PayloadAction<affiliate>) => {
    state.affiliate = action.payload
  }
}
export  { reducers }
